<template>
	<div class="page-in">
		<van-nav-bar :title="$t('商品')" fixed placeholder z-index="99" :border="false" v-if="isMobileFlag">
			<template #right>
				<span class="iconfont icon-filter" @click="show = true"></span>
			</template>
		</van-nav-bar>
		<div class="inside-page ">
			<div class="layui-container" v-if="allProducts.length > 0">
			<div class="breadcrumb">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }">{{$t('主页')}}</el-breadcrumb-item>
					<el-breadcrumb-item>{{$t('商品列表')}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
				<div class="filter-main">
					<div class="layui-form" v-if="!isMobileFlag">
						<div class="filter-row flex">
							<div class="filter-label">{{$t('价格筛选')}}：</div>
							<div class="filter-group flex-center">
								<div class="col">
									<el-input v-model="min_price" :placeholder="$t('最低价格')"></el-input>
								</div>
								<div class="col-space"></div>
								<div class="col">
									<el-input v-model="max_price" :placeholder="$t('最高价格')"></el-input>
								</div>
								<div class="col">
									<div class="col-select">
										<el-select v-model="price_sort" :placeholder="$t('价格排序')" @change="priceChange">
											<el-option :label="$t('从低到高')" value="1"></el-option>
											<el-option :label="$t('从高到低')" value="2"></el-option>
										</el-select>
									</div>
								</div>
								<div class="col">
									<el-checkbox v-model="sell_sort" :label="$t('销量')" @change="sellChange" border></el-checkbox>
								</div>
							</div>
							<div class="btn-group">
								<button class="layui-btn layui-btn-normal" @click="searchGoods">{{$t('搜索')}}</button>
								<button class="layui-btn layui-bg-gray" @click="searchRest">{{$t('重置')}}</button>
							</div>
						</div>
					</div>
				</div>
				<div class="section-head">
					{{$t('商品列表')}}
				</div>
				<div class="product-cells">
					<el-row :gutter="isMobileFlag?10:20" class="product-list">
						<el-col :xs="12" :sm="8" :md="6" v-for="(item,index) in allProducts" :key="`goods${index}`">
							<product-item :item="item" ></product-item>
						</el-col>
					</el-row>
				</div>
				<div class="ui-page" v-if="listTotal>20">
					<el-pagination
						background
						:small="isMobileFlag"
						:pager-count="5"
						layout="prev, pager, next"
						:current-page.sync="currentPage"
						@current-change="handleSizeChange"
						:page-size="listLimit"
						:total="listTotal"
					  ></el-pagination>
				</div>
			</div>
		</div>
		<Foot :active="1" v-if="isMobileFlag" />
		<van-popup v-model="show" position="top" :style="{ height: '90%' }"  closeable>
			<div class="filter-m">
				<div class="filter-m-cell ">
					<div class="filter-label">{{$t('价格筛选')}}：</div>
					<div class="filter-m-group flex">
						<div class="col">
							<el-input v-model="min_price" placeholder="0 VND"></el-input>
						</div>
						<div class="col-space"></div>
						<div class="col">
							<el-input v-model="max_price" placeholder="200,000,000 VND"></el-input>
						</div>
					</div>
				</div>
				<div class="filter-m-cell">
					<div class="filter-label">{{$t('分类')}}：</div>
					<el-radio-group v-model="type_id" >
						<el-row :gutter="10" class="filter-el-row">
							<el-col :span="12" v-for="(item,index) in this.typeData" :key="index">
								<el-radio class="type-radio" :label="item.id" border style="width: 100%;">
									 {{ replaceAmpersand($t(item.title)) }}
								</el-radio>
							</el-col>
						</el-row>
					</el-radio-group>
				</div>
				<div class="filter-label">{{$t('价格排序')}}：</div>
				<div class="filter-m-group">
					<el-radio-group v-model="price_sort" class="flex">
						<div class="col" >
							<el-radio style="width: 100%;" label="1" border>{{$t('从低到高')}}</el-radio>
						</div>
						<div class="m-col-space"></div>
						<div class="col" >
							<el-radio style="width: 100%;" label="2" border>{{$t('从高到低')}}</el-radio>
						</div>
					</el-radio-group>
					<div class="sell_sort-col" >
						<el-checkbox style="width: calc(50% - 5px);" v-model="sell_sort" :label="$t('销量')" border></el-checkbox>
					</div>
				</div>
				<div class="btn-m-group flex-center">
					<div class="btn-reset">
						<span class="iconfont icon-clear"></span>
					</div>
					<div class="flex-col">
						<button class="layui-btn layui-btn-normal" @click="mSearch">{{$t('搜索')}}</button>
					</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>
<script>
	import {index_goods_list_api,index_goods_type_api} from "@/api/index"
	import productItem from '@/components/productItem.vue'
	import Foot from "@/components/Foot.vue";
	export default {
		components: {
			Foot,
			productItem
		},
		data() {
			return {
				show: false,
				type_id:'',
				min_price: '',
				max_price: '',
				price_sort: '',
				sell_sort:0,
				allProducts: [],
				currentPage: 1,
				listPage: 1,
				listLimit: 20,
				listTotal: 0,
				typeData:[],
				keyword:'',
			};
		},
		computed: {
		    replacedString() {
		      return this.originalString.replace(/B&amp;B/g, 'B&B');
		    },
		},
		methods: {
			replaceAmpersand(title) {
			  // 替换 B&amp;B 为 B&B
			  return title.replace(/B&amp;B/g, 'B&B');
			},
			async getGoodsData() {
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				try {
					let param = {
						page: this.listPage,
						limit: this.listPage == 1 ? 20 : this.listLimit,
						min_price: this.min_price,
						max_price: this.max_price,
						price_sort: this.price_sort,
						title:this.keyword
					};
					if (this.sell_sort) {
						param['sell_sort'] = 1;
					}
					if (this.price_sort != "") {
						param['price_sort'] = this.price_sort;
					}
					if (this.type_id != "") {
						param['type_id'] = this.type_id;
					}
					const res = await index_goods_list_api(param);
					if (res && res.data.code == 1) {
						this.allProducts = res.data.data.lists;
						this.listTotal = res.data.data.total;
						loading.close();
					}
				} catch (error) {
					console.error('获取商品数据失败', error);
				}
			},
			async getGoodsType() {
				try {
					const res = await index_goods_type_api();
					if (res && res.data.code == 1) {
						this.typeData = res.data.data;
					}
				} catch (error) {
					console.error('获取商品数据失败', error);
				}
			},
			
			sellChange(e){
				this.getGoodsData();
			},
			priceChange(e){
				this.getGoodsData();
			},
			searchGoods(){
				if (this.min_price == "") {
					this.errorTips("请输入最低价格");
					return;
				}
				if (this.max_price == "") {
					this.errorTips("请输入最高价格");
					return;
				}
				this.getGoodsData();
				this.min_price = ""
				this.max_price = ""
			},
			handleSizeChange(e) {
			  this.listPage = e;
			  this.getGoodsData();
			},
			searchRest(){
				this.min_price = ""
				this.max_price = ""
				this.price_sort = ""
				this.type_id = ""
				this.sell_sort = 0
				this.getGoodsData();
			},
			mSearch(){
				this.getGoodsData();
				this.show = false
			}
		},
		watch: {
		    '$route.query.keyword': function(newKeyword) {
		      this.keyword = newKeyword;
			  this.getGoodsData()
		    }
		  },
		mounted() {
			if(this.$route.query.keyword){
				this.keyword = this.$route.query.keyword
			}
			if(this.$route.query.type_id){
				this.type_id = this.$route.query.type_id
			}
			this.getGoodsData()
			this.getGoodsType()
			
		}
	}
</script>